module.exports = __webpack_public_path__ + "img/comment4.c9d1850c.png";